<div class="standardpanel" style="margin-top: 0px !important;">
  <div class="container_dati_generali" style="margin-top: 0px !important;">
    <ng-template [ngIf]="contropartiPrecedenti.length > 0">
      <ul id="controparticollapseprecedenti" class="controparti">
        <li class="panel">
          <div class="controparte" style="background-color: #ccc; margin-top: -20px;">
            <div class="row">
              <div class="col-sm-3">
                <h4 class="titolo">
                  &nbsp;Nominativo
                </h4>
              </div>
              <div class="col-sm-4">
                <h4 class="titolo">
                  Codice fiscale/P.IVA
                </h4>
              </div>
              <!--<div class="col-sm-3">
                <h4 class="titolo">
                  Codice Cassa
                </h4>
              </div>-->
              <div class="col-sm-2" style="margin-left: 0; margin-top: -10px;" singleCheckBoxModInput [labelInput]="''"
                [showLabel]="true" [labelChecked]="'Tutti'" [labelNotChecked]="'Tutti'"
                [objectReference]="selezionaTutti" [showLabel]="true" [labelSemibold]="true"
                idInput="{{selezionaTutti}}" (onReturn)="selectAllControparti($event)"></div>
            </div>
          </div>
        </li>
        <ng-template ngFor let-controparte [ngForOf]="contropartiPrecedenti" let-i=index>
          <li class="panel">
            <div class="controparte">
              <div class="row">
                <a [attr.data-toggle]="'collapse'" href="#subcontroparteprecedenti{{i+1}}" attr.aria-expanded="false"
                  class="collapsed" [attr.aria-controls]="'subcontroparteprecedenti'+(i+1)"
                  [attr.data-parent]="'#controparticollapseprecedenti'">
                  <span>Apri</span>
                </a>
                <div class="col-sm-3">
                  <h4 class="titolo" *ngIf="controparte.parte?.nominativo">
                    {{ controparte.parte?.nominativo }}
                  </h4>
                  <h4 class="titolo"
                    *ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
                    {{ controparte.parte?.cognome + ' ' + controparte.parte?.nome }}
                  </h4>
                  <h4 class="titolo"
                    *ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
                    {{ controparte.parte?.ragioneSociale }}
                  </h4>
                </div>
                <div class="col-sm-4">
                  <ng-template
                    [ngIf]="controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
                    <p>
                      C/F: <strong> {{ controparte.parte.codiceFiscale }} </strong>
                    </p>
                  </ng-template>
                  <ng-template
                    [ngIf]="controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
                    <p>
                      P.IVA: <strong> {{ controparte.parte.partitaIva }} </strong>
                    </p>
                  </ng-template>
                </div>
                <!--<div class="col-sm-3">
                  <ng-template [ngIf]="controparte.parte?.matricola">
                    <p>
                      <strong> {{ controparte.parte.codiceMeccanografico }} </strong>
                    </p>
                  </ng-template>
                </div>-->
                <div class="col-sm-2" style="margin-left: 0;margin-top: -10px;" singleCheckBoxModInput [labelInput]="''"
                  [showLabel]="false" idInput="selected-{{i}}" [objectReference]="controparte?.selected"
                  (onReturn)="addControparteToList(controparte, $event, i)"></div>
              </div>

            </div>

            <ul class="collapse subcontroparte" id="subcontroparteprecedenti{{i+1}}">
              <li>
                <div class="container_tab_nav">
                  <p>Visualizza</p>
                  <ul class="nav nav-tabs two">
                    <li class="active"><a data-toggle="tab" href="#tabcontentprecedenti1_{{i}}">Associativa</a></li>
                    <li><a data-toggle="tab" href="#tabcontentprecedenti2_{{i}}">Anagrafica</a></li>
                  </ul>

                  <div class="tab-content">
                    <div id="tabcontentprecedenti1_{{i}}" class="tab-pane fade in active">
                      <form>
                        <div class="row">
                          <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
                            [labelInput]="'Legale di controparte'"
                            [valueInput]="controparte.legaleControparte ? (controparte.legaleControparte?.parte.nominativo) : ''">
                          </div>
                          <!--<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'date'"
                            [labelInput]="'Data associazione'" [valueInput]="controparte.dataAssociazione"></div>-->
                          <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'boolean'"
                            [labelInput]="'Cliente'" [valueInput]="controparte.cliente"></div>
                          <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'boolean'"
                            [labelInput]="'Rinunciatario'" [valueInput]="controparte.ritirato"></div>
                          <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'date'"
                            [labelInput]="'Data rinuncia'" [valueInput]="controparte.dataTermine"></div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12 bloccodati">
                            <p>
                              <label class="col-sm-12">Note</label> <span class="longtext">{{
                                controparte.note }}</span>
                            </p>
                          </div>

                        </div>
                      </form>

                    </div>
                    <div id="tabcontentprecedenti2_{{i}}" class="tab-pane fade">
                      <!--<div controparte_anagrafica_view [controparte]="controparte"></div>-->
                      <app-dati-generali-anagrafiche *ngIf="isPrd" [controparte]="controparte" [isPartiSearch]="true">
                      </app-dati-generali-anagrafiche>
                    </div>

                  </div>
                </div>
              </li>
            </ul>

          </li>
        </ng-template>
      </ul>
    </ng-template>

    <ng-template [ngIf]="contropartiPrecedenti.length === 0">
      <p>{{tipoFascicolo === 'parere' ? 'Nessun soggetto richiedente' : 'Nessuna parte' }} precedente</p>
    </ng-template>

    <div class="row">
      <p class="col-sm-3 col-xs-6" style="margin-top: 30px;">
        <button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
      </p>
      <p submitButton style="margin-top: 30px;"
        [disabled]="contropartiPrecedenti.length === 0 || contropartiSelezionate.length === 0"
        class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="'Inserisci'"
        (click)="inserisciFirstControparte()">
      </p>
    </div>

  </div>
</div>
